let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cILRP")).then(() => parcelRequire('frsBO'));